/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';

export default class Error extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const errors = this.props.errors.map((error, index) => (
      <li key={index}>
        <span>{error}</span>
      </li>
    ));
    return <ul className="errors">{errors}</ul>;
  }
}

Error.propTypes = {
  errors: PropTypes.array,
};
